"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var chargeController_1 = require("../chargeController");
var mmxlGetter_1 = require("./mmxlGetter");
function checkForValidFrequencyCapping(placement, value, isPresetRow, rateCardOptions) {
    if (isPresetRow) {
        return Promise.resolve(true);
    }
    var theAdformat = _.get(placement, "conditions.online.adFormat");
    if (!theAdformat) {
        return Promise.resolve(true);
    }
    if (theAdformat && theAdformat.toString() === "AGOF_Werbeform_0") {
        return Promise.resolve(false);
    }
    return mmxlGetter_1.MmxlGetter.getRateCard(placement.medium.key, rateCardOptions).then(function (ratecard) {
        if (!ratecard || !ratecard.frequencyCapping) {
            return false;
        }
        return mmxlGetter_1.MmxlGetter.getFrequencyCappingKits(ratecard.frequencyCapping).then(function (fcKit) {
            var currentKit = chargeController_1.ChargeController.getMostCurrent(fcKit);
            if (placement.medium.period === "KZ") {
                return hasDDCharge(currentKit, theAdformat.toString());
            }
            var charge = chargeController_1.ChargeController.getExtraCharge(currentKit.extraCharges, theAdformat, placement.medium.period);
            if (!charge) {
                return undefined;
            }
            if (value < 0) {
                return true;
            }
            return (value >= charge.min && (value <= charge.max || charge.max === 0));
        });
    });
}
exports.checkForValidFrequencyCapping = checkForValidFrequencyCapping;
function hasDDCharge(currentKit, adFormat) {
    var ddCharge = chargeController_1.ChargeController.getExtraCharge(currentKit.extraCharges, adFormat, "DD");
    return ddCharge !== undefined;
}
//# sourceMappingURL=checkForValidFrequencyCapping.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/datalayerHelpers/checkForValidFrequencyCapping.js
// module id = 47
// module chunks = 0